import { useSession } from "@src/appV2/Auth/api/useSession";
import { PACIFIC_TIME_ZONE } from "@src/appV2/Timezone/constants";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { zonedTimeToUtc } from "date-fns-tz";

export function useFormatTimestampForWorkplace() {
  const session = useSession();
  const sessionTimezone = session.profile?.tmz ?? PACIFIC_TIME_ZONE;
  return (timestamp: Date) => zonedTimeToUtc(timestamp, sessionTimezone).toISOString();
}
